"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _ui = require("@probeton/ui");

var _solarReact = require("@probeton/solar-react");

var _solarReact2 = require("@solar/solar-react");

var _elasticlunr = _interopRequireDefault(require("elasticlunr"));

var _Done = _interopRequireDefault(require("@material-ui/icons/Done"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _certificateColors = _interopRequireDefault(require("./certificateColors"));

var _ProductCardBody = _interopRequireDefault(require("../Product/ProductCardBody"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return _objectSpread({}, (0, _certificateColors["default"])('color'));
});

var CertificateValidity = function CertificateValidity(_ref) {
  var isValid = _ref.isValid;
  var classes = useStyles();
  return isValid ? /*#__PURE__*/_react["default"].createElement(_Done["default"], {
    className: isValid ? classes.green : classes.red
  }) : /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    className: isValid ? classes.green : classes.red
  });
};

var CertificateSearch = function CertificateSearch(_ref2) {
  var products = _ref2.products,
      loading = _ref2.loading,
      openCertificate = _ref2.openCertificate,
      _ref2$showProductsWit = _ref2.showProductsWithoutCertificates,
      showProductsWithoutCertificates = _ref2$showProductsWit === void 0 ? true : _ref2$showProductsWit,
      onlyMine = _ref2.onlyMine,
      setOnlyMine = _ref2.setOnlyMine,
      labels = _ref2.labels;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchInput = _useState2[0],
      setSearchInput = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedProduct = _useState4[0],
      setSelectedProduct = _useState4[1];

  var _showProductsWithoutCertificates = (0, _react.useMemo)(function () {
    return onlyMine ? false : showProductsWithoutCertificates;
  }, [showProductsWithoutCertificates, onlyMine]);

  var _products = (0, _react.useMemo)(function () {
    return products == null ? [] : products.map(function (product) {
      return _objectSpread(_objectSpread({}, product), {}, {
        certificates: product.certificates.filter(function (c) {
          return !!c;
        }).filter(function (_ref3) {
          var iAmResponsible = _ref3.iAmResponsible;
          return onlyMine ? iAmResponsible : true;
        }) // .filter(({ isValid }) => (onlyValid ? isValid : true))
        .map(function (c) {
          return _objectSpread(_objectSpread({}, c), {}, {
            productTitle: product.title,
            manufacturerKey: c.productionUnit.manufacturer.key,
            manufacturerName: c.productionUnit.manufacturer.name,
            manufacturerAddress: c.productionUnit.manufacturer.location.formatted_address,
            unitAddress: c.productionUnit.location.formatted_address
          });
        })
      });
    });
  }, [products, onlyMine]);

  var allCertificates = (0, _react.useMemo)(function () {
    return _products.map(function (product) {
      return product.certificates;
    }).flat();
  }, [_products, onlyMine]);
  var searchIndex = (0, _react.useMemo)(function () {
    var index = (0, _elasticlunr["default"])(function () {
      var self = this;
      ['key', 'productTitle', 'manufacturerKey', 'manufacturerName', 'manufacturerAddress', 'unitAddress'].forEach(function (field) {
        self.addField(field);
      });
      self.setRef('_id');
      self.saveDocument(false);
    });
    allCertificates.forEach(function (certificate) {
      index.addDoc(certificate);
    });
    return index;
  }, [allCertificates]);
  var filteredCertificateIds = (0, _react.useMemo)(function () {
    return searchInput.length > 2 ? searchIndex.search(searchInput, {
      fields: {
        key: {
          boost: 2
        },
        productTitle: {
          boost: 2
        },
        manufacturerKey: {
          boost: 2
        },
        manufacturerName: {
          boost: 2
        },
        manufacturerAddress: {
          boost: 2
        },
        unitAddress: {
          boost: 2
        }
      },
      expand: true,
      bool: 'OR'
    }).filter(function (_ref4) {
      var score = _ref4.score;
      return score > 0.2;
    }).map(function (_ref5) {
      var ref = _ref5.ref;
      return ref;
    }) : null;
  }, [allCertificates, searchIndex, searchInput]);
  var filteredProducts = (0, _react.useMemo)(function () {
    return (// eslint-disable-next-line no-nested-ternary
      (filteredCertificateIds != null ? _products.map(function (product) {
        var shouldShowProduct = product.certificates.some(function (_ref6) {
          var _id = _ref6._id;
          return filteredCertificateIds.includes(_id);
        });

        if (shouldShowProduct) {
          return _objectSpread(_objectSpread({}, product), {}, {
            certificates: product.certificates.filter(function (_ref7) {
              var _id = _ref7._id;
              return filteredCertificateIds.includes(_id);
            })
          });
        }

        return undefined;
      }).filter(function (product) {
        return product !== undefined;
      }) : _showProductsWithoutCertificates ? _products : _products.filter(function (p) {
        return p.certificates.length > 0;
      })).sort(function (a, b) {
        return a.key - b.key;
      })
    );
  }, [_showProductsWithoutCertificates, allCertificates, filteredCertificateIds]);
  return /*#__PURE__*/_react["default"].createElement(_solarReact2.Flex, {
    fullColumn: true
  }, /*#__PURE__*/_react["default"].createElement(_solarReact2.ResponsiveAppBar, {
    title: labels.title,
    actions: /*#__PURE__*/_react["default"].createElement(_solarReact.ResponsiveSearchField, {
      InputProps: {
        id: 'searchOffice'
      },
      placeholder: labels.search,
      value: searchInput,
      onChange: function onChange(value) {
        return setSearchInput(value);
      }
    }),
    extraToolbar: /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
      control: /*#__PURE__*/_react["default"].createElement(_core.Switch, {
        checked: onlyMine,
        onChange: function onChange(event) {
          setOnlyMine(event.target.checked);
        },
        name: "limitByResponsible"
      }),
      label: labels.onlyMine
    })
  }), /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, loading && /*#__PURE__*/_react["default"].createElement(_core.LinearProgress, {
    color: "primary"
  }), /*#__PURE__*/_react["default"].createElement(_ui.CardListOverviewToTableDetail, {
    setSelectedCardItem: function setSelectedCardItem(c) {
      if (!c) {
        setSelectedProduct(null);
      } else {
        var _id = c._id;
        setSelectedProduct(_id);
      }
    },
    selectedCardItem: filteredProducts.find(function (_ref8) {
      var _id = _ref8._id;
      return _id === selectedProduct;
    }),
    cardListOverview: {
      items: filteredProducts,
      renderCardBody: function renderCardBody(_ref9) {
        var certificates = _ref9.certificates,
            cover = _ref9.cover,
            title = _ref9.title,
            key = _ref9.key;
        return /*#__PURE__*/_react["default"].createElement(_ProductCardBody["default"], {
          certificates: certificates,
          cover: cover,
          title: key,
          subheader: title
        });
      }
    },
    tableDetail: {
      title: function title(_ref10) {
        var _title = _ref10.title;
        return _title;
      },
      subtitle: function subtitle(_ref11) {
        var renderTitle = _ref11.renderTitle;
        return renderTitle;
      },
      columns: [{
        width: 48,
        flexGrow: 0,
        label: '',
        dataKey: 'isValid'
      }, {
        width: 100,
        flexGrow: 0,
        label: labels.table.certificate,
        dataKey: 'renderKey'
      }, {
        width: 240,
        flexGrow: 1.0,
        label: labels.table.manufacturer,
        dataKey: 'manufacturerName'
      }, {
        width: 240,
        flexGrow: 1.0,
        label: labels.table.unit,
        dataKey: 'unitAddress'
      }],
      items: function items(o) {
        if (!o) {
          return [];
        }

        var certificates = o.certificates;
        return (certificates || []).sort(function (a, b) {
          return a.manufacturerName < b.manufacturerName ? -1 : 1;
        });
      },
      renderTableRow: function renderTableRow(_ref12) {
        var isValid = _ref12.isValid,
            key = _ref12.key,
            renderKey = _ref12.renderKey,
            manufacturerName = _ref12.manufacturerName,
            unitAddress = _ref12.unitAddress;
        return {
          isValid: /*#__PURE__*/_react["default"].createElement(CertificateValidity, {
            isValid: isValid
          }),
          key: key,
          renderKey: renderKey,
          manufacturerName: manufacturerName,
          unitAddress: unitAddress
        };
      },
      onItemClick: function onItemClick(item) {
        return openCertificate(item.rowData.key);
      }
    }
  })));
};

var _default = CertificateSearch;
exports["default"] = _default;